import React from "react";
import PropTypes from "prop-types";
import { noop, map, isEqual, isEmpty, capitalize } from "lodash";
import {
  Button,
  Pagination,
  Select,
  SearchSelect,
  Textarea,
} from "../../components/base";
import BaseTable from "../../components/BaseTable/BaseTable.component";
import { formatData, normalizeAmount } from "../../utils/transformer.util";
import language from "../../languages";
import { errorAlert } from "../../utils/alert.util";
import { LIST_PENDAFTARAN_PPDB_LIST_TABLE_FIELDS } from "../../constants/Student/student.constant";

const initialContent = {
  loading: true,
  list: [],
  currentPage: 1,
  total: 1,
  totalPage: 1,
  error: false,
};

export default class StrukturUnit extends BaseTable {
  constructor(props) {
    super(props);
    this.onClickAdd = this.onClickAdd.bind(this);
    this._onFormChange = this._onFormChange.bind(this);
    this.onClickEdit = this.onClickEdit.bind(this);
    this.onClickRutin = this.onClickRutin.bind(this);
    this.onClickTidakRutin = this.onClickTidakRutin.bind(this);
    this.handleGetData = this.handleGetData.bind(this);
    this.onChangePage = this.onChangePage.bind(this);
    this._onSearchContent = this._onSearchContent.bind(this);
    this._onChangeFilter = this._onChangeFilter.bind(this);
    this._getPrmPositionOption = this._getPrmPositionOption.bind(this);
    this._getPrmPositionAdmOption = this._getPrmPositionAdmOption.bind(this);
    this._getParamOptionsAcademics = this._getParamOptionsAcademics.bind(this);
    this._getPeriodsOptions = this._getPeriodsOptions.bind(this);
    this._initializeData = this._initializeData.bind(this);
    this._getSchoolUnitsManageOptions =
      this._getSchoolUnitsManageOptions.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.onPosting = this.onPosting.bind(this);
    this.onGenerate = this.onGenerate.bind(this);
    this._getNotesUnposting = this._getNotesUnposting.bind(this);
    this._getSchoolUnitsOptions = this._getSchoolUnitsOptions.bind(this);
    this._onClickSet = this._onClickSet.bind(this);

    const { user } = this.props;
    const { school_unit } = user;
    const { levels_id } = school_unit;
    this.state = {
      page: 1,
      selected: {},
      isTable: true,
      content: initialContent,
      unchecked: {},
      filters: {},
      list: [],
      form: {
        value: {
          details: [],
          units_id: school_unit.id,
        },
        error: {
          details: [],
        },
      },
      param: {},
      availablePositions: [],
      filtered: false,
    };
  }

  componentDidMount() {
    const { user } = this.props;
    const { organizations_id, user_group } = user;
    const { content, form, filters } = this.state;
    let savedForm =
      JSON.parse(window.localStorage.getItem("strukturForm")) || "";
    let savedFilters =
      JSON.parse(window.localStorage.getItem("strukturFilters")) || filters;
    if (savedForm != "" && user.id != savedForm.value.user_id) {
      savedForm = "";
      savedFilters = filters;
    }
    this._initializeData(savedForm);
    if (savedForm != "") {
      this.setState((prevState) => ({
        ...prevState,
        form: {
          ...prevState.form,
          value: {
            ...prevState.form.value,
            levels_id: savedForm.value.levels_id,
            units_id: savedFilters.units_id ? savedFilters.units_id : "",
            details: savedForm.value.details,
          },
        },
        filters: {
          ...prevState.filters,
          units_id: savedFilters.units_id ? savedFilters.units_id : "",
          // entrance_year : savedFilters.entrance_year,
        },
      }));

      // this._getParamOptionsAcademics("classrooms", {
      //   levels_id: savedForm.value.levels_id,
      //   classes_id: savedForm.value.classes_id,
      //   units_id: savedForm.value.units_id.value,
      //   organizations_id,
      // });

      if (user_group.name === "pusat") {
        this._getPeriodsOptions({
          units_id: savedFilters.units_id ? savedFilters.units_id.value : "",
        });
      }
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const { form, param } = this.state;
    const { details } = form.value;
    const { form: prevForm } = prevState;
    const { details: prevDetails } = prevForm.value;

    if (
      (!this.state.availablePositions ||
        this.state.availablePositions.length !== details.length) &&
      Array.isArray(param.positions)
    ) {
      // Bikin availablePositions sebanyak details, isinya salinan dari param.positions
      const newAvailable = details.map(() => [...param.positions]);

      this.setState({ availablePositions: newAvailable });
    }

    if (details !== prevDetails) {
      this._getPrmPositionOption();
      this._getPrmPositionAdmOption();
    }
  }

  async _initializeData(savedFilters = {}) {
    const { user } = this.props;
    const { content } = this.state;
    const { school_unit, user_group } = user;

    // if (user_group.name !== "pusat" || user_group.name !== 'pengurus') {
    await this._getPeriodsOptions({ units_id: school_unit.id });

    this._getNotesUnposting();
    // }
    await this._getSchoolUnitsOptions();

     if (user_group.name == 'pusat' || user_group.name === 'pengurus') {
      this.setState(prevState => ({
        filters: {
          ...prevState.filters,
          period: savedFilters.period,
        },
      }), () => {
        // commonActions.setLoading({ show: true });
        this._onSearchContent();
      });
    } else {
      this.setState(prevState => ({
        filters: {
          ...prevState.filters,
        },
      }), () => {
        // commonActions.setLoading({ show: true });
        this._onSearchContent();
      });
    }
  }

  async _getSchoolUnitsOptions(filters = {}) {
    const { getSchoolUnitsOptions } = this.props;
    const { form } = this.state;
    const { units_id } = form.value;
    const res = await getSchoolUnitsOptions(filters);
    const selectedUnits = res.find(item => item.value == units_id);

    // console.log(units_id)
    this.setState(prevState => ({
      ...prevState,
      form: {
        ...prevState.form,
        value: {
          ...prevState.form.value,
          levels_units: selectedUnits ? selectedUnits.attributes.levels_id : '',
        },
      },
      param: {
        ...prevState.param,
        units: res,
      },
    }));
  }

  async _getSchoolUnitsManageOptions(filters = {}) {
    const { getSchoolUnitsManageOptions } = this.props;
    const { form } = this.state;
    const { units_id } = form.value;
    const res = await getSchoolUnitsManageOptions(filters);
    const selectedUnits = res.find((item) => item.value == units_id);

    this.setState((prevState) => ({
      ...prevState,
      form: {
        ...prevState.form,
        value: {
          ...prevState.form.value,
          levels_units: selectedUnits ? selectedUnits.attributes.levels_id : "",
        },
      },
      param: {
        ...prevState.param,
        units: res,
      },
    }));
  }

  async _getStudentSPPOptions(filters = {}) {
    const { getStudentSPPOptions } = this.props;
    const res = await getStudentSPPOptions(filters);
    this.setState((prevState) => ({
      ...prevState,
      param: {
        ...prevState.param,
        student_prm: res,
      },
    }));
  }

  async _getNotesUnposting(payload = {}) {
    const { filters, param, form } = this.state;
    const { getNotesUnposting, user, getPeriodsOptions } = this.props;
    const { organizations_id, school_unit, user_group } = user;
    const { units_id, levels_id } = school_unit;
    console.log(form.value);
    const units =
      user_group.name == "pusat" || user_group.name == "perwakilan"
        ? filters.units_id
          ? filters.units_id
          : ""
        : school_unit.id;
    console.log(units);

    const res = await getNotesUnposting({
      ...payload,
      organizations_id,
      units_id: units,
      period_id: filters.period_id,
    });
    // filters.organizations_id = organizations_id;
    // filters.units_id = units_id;

    this.setState((prevState) => ({
      ...prevState,
      notes: res,
    }));
  }

  _onChangeFilter(e) {
    const { user, getPeriodsOptions } = this.props;
    const { form, filters } = this.state;
    const { organizations_id, school_unit } = user;
    const { target } = e;
    const { value, name } = target;
    this.setState(
      (prevState) => ({
        ...prevState,
        filters: {
          ...prevState.filters,
          [name]: value,
        },
        // param: {
        //   ...prevState.param,
        //   student: res,
        // },
      }),
      () => {
        if (name === "units_id") {
          this._getPeriodsOptions({ units_id: value.value });

          this.setState((prevState) => ({
            ...prevState,
            isTable: true,
            form: {
              ...prevState.form,
              value: {
                ...prevState.form.value,
                classrooms_id: "",
                units_id: value,
              },
            },
            filters: {
              ...prevState.filters,
              // entrance_year:''
              // periods: periods_value,
            },
          }));
        }
        this._onSearchContent();
      }
    );
  }

   _onClickSet() {
    this.setState(prevState => ({
      ...prevState,
      isTable: false,
      filters: {
        ...prevState.filters,
      },
    }),
    () => {
      this._onSearchContent();
    });
  }

  async _onSearchContent(params = {}) {
    const { filters, form, param } = this.state;
    const {
      students_id = "",
      entrance_year,
      units_id,
      period_id,
      period,
    } = filters;
    const {
      handleListPPDBOffline,
      user,
      handleListStudentsPPDBF07,
      handleListStudentsPPDB,
      handleListStudentsClassDivGeneral,
      handleListStudentsPPDBRicci,
      handleListPPDBOfflineUPD,
    } = this.props;
    const { organizations_id, school_unit, user_group } = user;
    const { levels_id } = school_unit;

    let year = "";
    if (entrance_year) {
      year = entrance_year.toString().substring(2);
    }
    // let ent = JSON.parse(window.localStorage.getItem('entranceYear')) || "";
    // let savedForm = JSON.parse(window.localStorage.getItem('strukturForm')) || "";
    // let savedFilters = JSON.parse(window.localStorage.getItem('strukturFilters')) || filters;

    let periods_value = {};
    if (user_group.name == "pusat") {
      const param = this.state.param.units;
      const periods = units_id
        ? param.find((i) => i.value == units_id.value)
          ? param.find((i) => i.value == units_id.value).periods
          : ""
        : "";

      map(periods, (data, idx) => {
        const date = new Date();
        const start_date = new Date(data.attributes.start_date);
        if (date > start_date) {
          // tahun ajaran selanjutnya
          if (periods[idx + 1]) {
            periods_value = periods[idx + 1].value;
          }
        }
      });
    }

    const periods_year = periods_value
      ? periods_value.toString().substring(2)
      : "";
    this.setState(async () => {
      try {
        const { handleGetDetailsPosition, user } = this.props;
        const { school_unit, organizations_id } = user;
        const result = await handleGetDetailsPosition({
          organizations_id,
            units_id: user_group.name=='pusat' || user_group.name === 'pengurus'?filters.units_id.value:school_unit.id,
          period_id: filters.period_id,
          filters,
        });

        this.setState((prevState) => ({
          ...prevState,
          form: {
            ...prevState.form,
            value: {
              ...prevState.form.value,
              details: result,
            },
          },
          // param: {
          //   ...prevState.param,
          //   positions: prm_fix,
          // }
        }));
      } catch (err) {
        // if (this.isMount) {
        this.setState((prevState) => ({
          ...prevState,
          form: {
            ...prevState.form,
            value: {
              ...prevState.form.value,
              details: [],
            },
          },
          // param: {
          //   ...prevState.param,
          //   positions: [],
          // }
        }));
      } finally {
        window.localStorage.setItem(
          "strukturForm",
          JSON.stringify(this.state.form)
        );
        window.localStorage.setItem(
          "strukturFilters",
          JSON.stringify(this.state.filters)
        );
      }
      // }
    });
  }

  async _getPeriodsOptions(filters = {}) {
    const { getPeriodsOptions, user } = this.props;
    const { organizations_id, school_unit, user_group } = user;
    const { form } = this.state;
    const { units_id } = form.value;
    const res = await getPeriodsOptions(filters);

    map(res, (data, idx) => {
      const date = new Date();
      const start_date = new Date(data.attributes.start_date);
      if (date > start_date) {
        // tahun ajaran sekarang
        this.setState((prevState) => ({
          ...prevState,
          filters: {
            ...prevState.filters,
            period: data.label,
            period_id: data.value,
          },
          form: {
            ...prevState.form,
            value: {
              ...prevState.form.value,
              period_id: data.value,
            },
          },
        }));
      }
    });

    this.setState((prevState) => ({
      ...prevState,
      param: {
        ...prevState.param,
        periods: res,
      },
    }));
  }

  _onFormChange(event) {
    const { form, param } = this.state;
    const { details } = form.value;
    const { user } = this.props;
    const { school_unit, organizations_id } = user;
    const { name, value, dataset, checked, type } = event.target;
    const {
      inputType = "text",
      inputArray = false,
      arrayPosition = 0,
      fieldName,
    } = dataset;
    this.setState(
      (prevState) => {
        let newList = [];
        let newListError = [];
        let formattedValue = value;

        if (inputType === "number") {
          formattedValue = normalizeAmount(value);
        }
        if (inputArray) {
          if (type === "checkbox") {
            formattedValue = checked;
          }
          newList = prevState.form.value[fieldName] || [];
          newListError = prevState.form.error[fieldName] || [];
          if (name === "nip") {
            const position_code = details[arrayPosition].position_code;

            const prmStaff =
              details[arrayPosition].position_code == "PL-38"
                ? param.positions_adm
                : param.positions;
            const selectedStaff = prmStaff.find((item) => item.value === value);

            const currentDetail = details[arrayPosition];
            const positionCode = currentDetail.position_code;
            const previousNip = currentDetail && currentDetail.nip;

            //  if (specialCodes.includes(position_code)) {
            //     // Tunggu state form.value.details selesai di-update
            //     setTimeout(() => {
            //       const { form } = this.state;
            //       const updatedDetails = form.value.details;

            //       const newAvailablePositions = updatedDetails.map((_, idx) => {
            //         const excludedNips = updatedDetails
            //           .map((d, i) => (i !== idx ? d.nip : null))
            //           .filter(Boolean);

            //         return param.positions.filter((p) => !excludedNips.includes(p.value));
            //       });

            //       this.setState({ availablePositions: newAvailablePositions });
            //     }, 0);
            //   }

            setTimeout(() => {
              const { form } = this.state;
              const updatedDetails = form.value.details;

              const specialCodes = ["PL-58", "PL-59", "PL-60"];

              // Ambil NIP yang dipilih hanya dari baris yang berkode khusus
              const specialNips = updatedDetails
                .filter((d) => specialCodes.includes(d.position_code) && d.nip)
                .map((d) => d.nip);

              const newAvailablePositions = updatedDetails.map((row, idx) => {
                const isSpecial = specialCodes.includes(row.position_code);

                if (!isSpecial) {
                  return param.positions; // ⬅️ tidak difilter
                }

                // Filter: hanya hilangkan NIP yang sudah dipilih oleh baris berkode khusus lainnya
                const excludedNips = specialNips.filter(
                  (nip) => nip !== row.nip
                );
                return param.positions.filter(
                  (p) => !excludedNips.includes(p.value)
                );
              });

              this.setState({ availablePositions: newAvailablePositions });
            }, 0);

            if (
              school_unit.levels_id == 4 ||
              school_unit.levels_id == 5 ||
              school_unit.levels_id == 6
            ) {
              newList[arrayPosition].error_nip = "";

              const current = details[arrayPosition];
              const isConflict = details.some(
                (item, idx) =>
                  idx !== arrayPosition &&
                  item.nip != null &&
                  item.nip === value &&
                  item.flag === current.flag
              );

              if (isConflict) {
                formattedValue = "";
                newList[arrayPosition].error_nip = "Nama Sudah Dipilih";
              } else {
                newList[arrayPosition].error_nip = "";
              }
            }

            //   if (school_unit.levels_id == 2 || school_unit.levels_id == 3){
            //        newList[arrayPosition].error_nip = '';

            //   const current = details[arrayPosition];
            //   const isConflict = details.filter((item, idx) =>
            //   idx !== arrayPosition &&
            //   item.nip != null &&
            //   item.nip === value &&
            //   //  item.nip.toString() === value.toString() &&
            //   item.flag === current.flag
            // );

            //  if (isConflict.length >= 2) {
            //     formattedValue = "";
            //     newList[arrayPosition].error_nip = "NIP Sudah Dipilih Dua kali";
            //   }
            //   else {
            //     newList[arrayPosition].error_nip = "";

            //   }
            //   }
            newList[arrayPosition].staff_name = selectedStaff.label;
          }

          if (name === "nip2") {
            newList[arrayPosition].error_nip = "";

            const selectedStaffAdm = param.positions_adm.find(
              (item) => item.value === value
            );

            newList[arrayPosition].staff_name = selectedStaffAdm.label;
          }
          newList[arrayPosition][name] = formattedValue;
          if (name === "code_of_account") {
            newList[arrayPosition].isCredit = value.type;
          }
          if (!isEmpty(newListError[arrayPosition])) {
            newListError[arrayPosition][name] = "";
          }
        }
        return {
          form: {
            value: {
              ...prevState.form.value,
              ...(inputArray
                ? { [fieldName]: newList }
                : { [name]: formattedValue }),
            },
            error: {
              ...prevState.form.error,
              ...(inputArray ? { [fieldName]: newListError } : { [name]: "" }),
            },
          },
        };
      },
      () => {
        if (name === "levels_id") {
          this._getClassesOptions({ filters: { levels_id: [value] } });
        }
        if (name === "classes_id") {
          this._getParamOptionsAcademics("classrooms", {
            classes_id: value,
            organizations_id,
          });
        }
      }
    );
  }

  handleGetData(payload = {}) {
    const { handleListPPDBOffline, user } = this.props;
    const { units_id, workingUnit, id, user_group, profile, organizations_id } =
      user;
    let unit_id = units_id;

    if (unit_id === null && workingUnit && workingUnit.id) {
      unit_id = workingUnit.id;
    }
    // const res = await handleListPPDBOffline({
    //   ...payload,
    //   user_id: id,
    //   organizations_id: organizations_id,
    // });

    this.setState({
      // list: res,
    });
  }

  async _getParamOptionsAcademics(type, filters = {}) {
    const { getParamOptionsAcademics, user } = this.props;
    const { organizations_id } = user;
    if (type === "classrooms" || type === "classrooms") {
      filters.organizations_id = organizations_id;
    } else {
      delete filters.organizations_id;
    }
    const res = await getParamOptionsAcademics(filters, type);
    this.setState((prevState) => ({
      ...prevState,
      param: {
        ...prevState.param,
        [type]: res,
      },
    }));
  }

  async _getPrmPositionOption() {
    const { getPrmPositionOption, user, handleGetDetailsPosition } = this.props;
    const { form, param, filters } = this.state;
    const { details } = form.value;
    const { school_unit, organizations_id } = user;
    const { levels_id } = school_unit;
    const res = await getPrmPositionOption({
      unit_code: school_unit.unit_code,
    });

    const nip_default = details
      .filter((i) => i.is_default == 1)
      .map((i) => i.nip);
    const filtered = details
      .filter(
        (i) =>
          i.is_default == 1 &&
          !["PL-09", "PL-10", "PL-11"].includes(i.position_code)
      )
      .map((i) => i.nip);

    // console.log(nip_default)
    // console.log(filtered)
    // console.log(res)
    // console.log(res?res.filter(i => !filtered.includes(i.value)):'')
    let prm_fix = [];
    if (levels_id == 2 || levels_id == 3 || levels_id == 7) {
      prm_fix = res ? res.filter((i) => !filtered.includes(i.value)) : "";
    } else {
      prm_fix = res ? res.filter((i) => !nip_default.includes(i.value)) : "";
    }

    this.setState((prevState) => ({
      ...prevState,
      param: {
        ...prevState.param,
        positions: prm_fix,
      },
    }));
  }

  async _getPrmPositionAdmOption() {
    const { getPrmPositionAdmOption, user, handleGetDetailsPosition } =
      this.props;
    const { form, param, filters } = this.state;
    const { details } = form.value;
    const { school_unit, organizations_id } = user;
    const res = await getPrmPositionAdmOption({
      unit_code: school_unit.unit_code,
    });

    this.setState((prevState) => ({
      ...prevState,
      param: {
        ...prevState.param,
        positions_adm: res,
      },
    }));
  }

  onClickAdd() {
    const { history } = this.props;
    history.push("/dashboard/kesiswaan/pendaftaran-ppdb");
  }

  onClickEdit(val) {
    const { history } = this.props;
    history.push("/dashboard/kesiswaan/pendaftaran-ppdb", {
      data: val,
      isEdit: true,
    });
  }

  onClickRutin(val) {
    const { history } = this.props;
    const { form } = this.state;
    val.units_id = form.value.units_id.value;

    if (val.no_va == "" || val.no_va == null) {
      errorAlert({
        title: "No VA belum tersedia.",
        errorMessage: "Mohon masukkan nomor pendaftaran di Data Siswa",
      });
    } else {
      history.push("/dashboard/tagihan-siswa/create-invoice/rutin/ppdb", {
        data: val,
        units: form.value.units_id,
      });
    }
  }

  onClickTidakRutin(val) {
    const { history } = this.props;
    const { form } = this.state;
    val.units_id = form.value.units_id.value;

    if (val.no_va == "" || val.no_va == null) {
      errorAlert({
        title: "No VA belum tersedia.",
        errorMessage: "Mohon masukkan nomor pendaftaran di Data Siswa",
      });
    } else {
      history.push("/dashboard/tagihan-siswa/create-invoice/tidak-rutin", {
        data: val,
      });
    }
  }

  onClickTidakRutinRICCI(val) {
    const { history } = this.props;
    const { form } = this.state;
    val.units_id = form.value.units_id.value;
    if (val.no_va == "" || val.no_va == null) {
      errorAlert({
        title: "No VA belum tersedia.",
        errorMessage: "Mohon masukkan nomor pendaftaran di Data Siswa",
      });
    } else {
      history.push(
        "/dashboard/tagihan-siswa/create-invoice/tidak-rutin-general",
        {
          data: val,
        }
      );
    }
  }

  onChangePage(page) {
    const { listAmount, keywords } = this.state;
    const offset = listAmount * (page - 1);
    this._onSearchContent({
      limit: listAmount,
      keywords,
      offset,
      page,
    });
  }

  async onSubmit() {
    const { history, handleUpdateDetailsPosition } = this.props;
    const { form } = this.state;
    const { value } = form;

    // Cek jika ada NIP kosong
    const foundEmptyNip = value.details.some(
      (detail) => !detail.nip || detail.nip.trim() === ""
    );

    // if (foundEmptyNip) {
    //    errorAlert({
    //           title: 'Terjadi Kesalahan',
    //           errorMessage: 'Tidak boleh ada NIP yang kosong.',
    //         });
    //   return; // hentikan proses submit
    // }

    await handleUpdateDetailsPosition(value);
    history.push("/dashboard/pengaturan/struktur-unit");
    history.go(0);
  }

  async onPosting() {
    const { history, handlePostingPosition } = this.props;
    const { form } = this.state;
    const { value } = form;

    // Cek jika ada NIP kosong
    const foundEmptyNip = value.details.some(
      (detail) => !detail.nip || detail.nip.trim() === ""
    );

    // if (foundEmptyNip) {
    //    errorAlert({
    //           title: 'Terjadi Kesalahan',
    //           errorMessage: 'Tidak boleh ada NIP yang kosong.',
    //         });
    //   // alert('Tidak boleh ada NIP yang kosong dalam data detail.');
    //   return; // hentikan proses submit
    // }

    await handlePostingPosition(value);
    history.push("/dashboard/pengaturan/struktur-unit");
    history.go(0);
  }

  async onGenerate() {
    const { history, generateStructur, user } = this.props;
    const { filters } = this.state;
    const { school_unit, organizations_id } = user;
    const { form } = this.state;
    const { value } = form;

    console.log(value);
    await generateStructur({
      organizations_id,
      units_id: school_unit.id,
      period: filters.period,
    });
    history.push("/dashboard/pengaturan/struktur-unit");
    history.go(0);
  }

  render() {
    const { user } = this.props;
    const { school_unit, user_group } = user;
    const { date_open, date_close } = school_unit;
    const { form, filters, param, notes, isTable} = this.state;
    const { details } = form.value;
    const prm_usergroups = param.userGroups;
    const prm_perwakilan = param.perwakilan_prm ? param.perwakilan_prm : "";
    const prm_units = param.units ? param.units : "";
    const All = [{ value: "all", label: "Semua Perwakilan", attributes: {} }];
    const AllUnit = [{ value: "all", label: "Semua Unit", attributes: {} }];
    const perwakilan_all = [...All, ...prm_perwakilan];
    // const units_all = [...AllUnit, ...prm_units];
    const prm_positions = param.positions ? param.positions : "";
    console.log(user_group.name);
    const prm_block = [
      { value: 0, label: "Semua Tidak Aktif" },
      { value: 1, label: "Semua Aktif" },
    ];

    const prm_is_block = [
      { value: 0, label: "Tidak Aktif" },
      { value: 1, label: "Aktif" },
    ];

    const userStudents = prm_usergroups
      ? prm_usergroups.find((e) => e.label == "student")
      : "";

    const formattedNotes = notes
      ? notes
          .map((item) => {
            const [date, time] = item.created_at.split(" ");
            return `${date}  ${item.notes}\n${time}`;
          })
          .join("\n\n")
      : "";
    const date = new Date();
    const today = date.toISOString().split("T")[0];

    // console.log(formatted); // Output: 2025-07-01
    const is_posting = details ? (details[0] ? details[0].is_posting : "") : "";

    // Format ke Bahasa Indonesia
    const formatTanggal = (tgl) => {
      const date = new Date(tgl);
      return date.toLocaleDateString("id-ID", {
        day: "2-digit",
        month: "long",
        year: "numeric",
      });
    };

    return (
      <div className="manage-registration">
        <h1>Jabatan Struktural</h1>
        <hr />
          
        {(user_group.name == "pusat" || user_group.name == "pengurus") ? (
          <>
            <div>
              <div className="absensi-rekap__custom-form-row">
                <div className="absensi-rekap__custom-form-row__field">
                  <SearchSelect
                    noMargin
                    async={false}
                    name="units_id"
                    list={param.units}
                    inputArray
                    onClick={this._onChangeFilter}
                    placeholder="Pilih Unit"
                    value={form.value.units_id}
                    rightIcon="icon-search"
                    label="Pilih Unit"
                  />
                </div>
                <div className="absensi-rekap__custom-form-column__field">
                  <Select
                    name="period_id"
                    label="Tahun Ajaran"
                    placeholder="Pilihan"
                    onChange={this._onChangeFilter}
                    data={param.periods}
                    value={filters.period_id}
                    // disabled
                  />
                </div>
              </div>
              {/* {user_group.name == 'pusat' || user_group.name === 'pengurus'? */}
                   <Button
                          className="button_save"
                          title="Proses"
                          onClick={this._onClickSet}
                          />
                          {/* :""} */}
              <div
                style={{
                  backgroundColor: "#FEF3C7", // kuning muda
                  border: "1px solid #FCD34D",
                  borderRadius: "12px",
                  padding: "16px",
                  fontSize: "12px",
                  color: "#4B5563",
                  marginBottom: "20px",
                  marginTop: "20px",
                }}
              >
                {"Tanggal Buka Pengisian Jabatan Struktural " +
                  formatTanggal(date_open) +
                  ", Tanggal Tutup Pengisian Jabatan Struktural " +
                  formatTanggal(date_close)}
              </div>
              {!isTable?
              <div className="manage-registration">
                <div className="fund-request__content">
                  <table className="table-structur">
                    <thead>
                      <tr>
                        <th>Jabatan</th>
                        <th>Nama Pegawai</th>
                      </tr>
                    </thead>
                    {/* <h1 style={{marginLeft:"100%"}}>Jabatan</h1> */}
                    <tbody>
                      {map(details, (list, idx) => (
                        <tr key={`budget_row_${idx}`}>
                          <td
                            key={`table_${idx}`}
                            style={{ textAlign: "left", fontWeight: "bold" }}
                          >
                            {list.position}
                          </td>
                          {(() => {
                            list.staff = list.nip;
                            // if(list.position.split(" ")[0] == 'Kepala' || list.position.split(" ")[0] == 'Tenaga'){
                            if (list.is_default == 1) {
                              return <td>{list.staff_name}</td>;
                            } else {
                              if (list.is_posting == 0) {
                                return (
                                  <td key={`table__${idx}`}>
                                    <Select
                                      placeholder="Pilihan"
                                      data-input-array
                                      data-array-position={idx}
                                      data-field-name="details"
                                      name="nip"
                                      value={list.nip}
                                      error={list.error_nip}
                                      arrayPosition={idx}
                                      disabled={true}
                                      // data={form.value.graduate === 1?[...lulus, ...tidak_lulus]:[...naik, ...tidak_naik]}
                                      data={
                                        ["PL-58", "PL-59", "PL-60"].includes(
                                          list.position_code
                                        )
                                          ? this.state.availablePositions[
                                              idx
                                            ] || []
                                          : list.position_code === "PL-38"
                                          ? param.positions_adm
                                          : param.positions
                                      }
                                      onChange={this._onFormChange}
                                    />
                                  </td>
                                );
                              } else {
                                return <td>{list.staff_name}</td>;
                              }
                            }
                          })()}
                          {/* {this._renderButtons(list)} */}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
              :''}
            </div>
          </>
        ) : (
          <>
            {today >= date_open && today < date_close ? (
              <div>
                <div className="absensi-rekap__custom-form">
                  <br />
                  {isEmpty(details) ? (
                    <Button
                      title="Generate Struktur"
                      onClick={this.onGenerate}
                    />
                  ) : (
                    ""
                  )}
                  <div className="absensi-rekap__custom-form-row">
                    {/* <div className="absensi-rekap__custom-form-row__field"> */}
                    <Select
                      name="period_id"
                      label="Tahun Ajaran"
                      placeholder="Pilihan"
                      onChange={this._onChangeFilter}
                      data={param.periods}
                      value={filters.period_id}
                      disabled
                    />
                  </div>
                  <div
                    style={{
                      backgroundColor: "#FEF3C7", // kuning muda
                      border: "1px solid #FCD34D",
                      borderRadius: "12px",
                      padding: "16px",
                      fontSize: "12px",
                      color: "#4B5563",
                      marginBottom: "20px",
                      marginTop: "20px",
                    }}
                  >
                    {"Tanggal Buka Pengisian Jabatan Struktural " +
                      formatTanggal(date_open) +
                      ", Tanggal Tutup Pengisian Jabatan Struktural " +
                      formatTanggal(date_close)}
                  </div>
                  {!isEmpty(notes) ? (
                    (
                      details
                        ? details[0]
                          ? details[0].is_posting == 0
                          : ""
                        : ""
                    ) ? (
                      <div>
                        <Textarea
                          name="notes"
                          label="Catatan"
                          placeholder="Pilihan"
                          onChange={this._onChangeFilter}
                          value={formattedNotes}
                          readOnly
                          style={{ height: "120px" }}
                          // disabled
                        />
                      </div>
                    ) : (
                      ""
                    )
                  ) : (
                    ""
                  )}
                </div>
                <div className="manage-registration">
                  <div className="fund-request__content">
                    <table className="table-structur">
                      <thead>
                        <tr>
                          <th>Jabatan</th>
                          <th>Nama Pegawai</th>
                        </tr>
                      </thead>
                      {/* <h1 style={{marginLeft:"100%"}}>Jabatan</h1> */}
                      <tbody>
                        {map(details, (list, idx) => (
                          <tr key={`budget_row_${idx}`}>
                            <td
                              key={`table_${idx}`}
                              style={{ textAlign: "left", fontWeight: "bold" }}
                            >
                              {list.position}
                            </td>
                            {(() => {
                              list.staff = list.nip;
                              // if(list.position.split(" ")[0] == 'Kepala' || list.position.split(" ")[0] == 'Tenaga'){
                              if (list.is_default == 1) {
                                return <td>{list.staff_name}</td>;
                              } else {
                                if (list.is_posting == 0) {
                                  return (
                                    <td key={`table__${idx}`}>
                                      <Select
                                        placeholder="Pilihan"
                                        data-input-array
                                        data-array-position={idx}
                                        data-field-name="details"
                                        name="nip"
                                        value={list.nip}
                                        error={list.error_nip}
                                        arrayPosition={idx}
                                        // data={form.value.graduate === 1?[...lulus, ...tidak_lulus]:[...naik, ...tidak_naik]}
                                        data={
                                          ["PL-58", "PL-59", "PL-60"].includes(
                                            list.position_code
                                          )
                                            ? this.state.availablePositions[
                                                idx
                                              ] || []
                                            : list.position_code === "PL-38"
                                            ? param.positions_adm
                                            : param.positions
                                        }
                                        onChange={this._onFormChange}
                                      />
                                    </td>
                                  );
                                } else {
                                  return <td>{list.staff_name}</td>;
                                }
                              }
                            })()}
                            {/* {this._renderButtons(list)} */}
                          </tr>
                        ))}
                      </tbody>
                    </table>
                    {(
                      details
                        ? details[0]
                          ? details[0].is_posting == 0
                          : ""
                        : ""
                    ) ? (
                      <div>
                        <div className="add-budget">
                          <Button
                            type="submit"
                            title="SIMPAN"
                            onClick={this.onSubmit}
                          />

                          <br></br>
                          <Button
                            title="AJUKAN KE PUSAT"
                            onClick={this.onPosting}
                          />
                        </div>
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
              </div>
            ) : (
              <div>
                <div className="absensi-rekap__custom-form-row">
                  {/* <div className="absensi-rekap__custom-form-row__field"> */}
                  <Select
                    name="period_id"
                    label="Tahun Ajaran"
                    placeholder="Pilihan"
                    onChange={this._onChangeFilter}
                    data={param.periods}
                    value={filters.period_id}
                    disabled
                  />
                </div>
                <div
                  style={{
                    backgroundColor: "#FEF3C7", // kuning muda
                    border: "1px solid #FCD34D",
                    borderRadius: "12px",
                    padding: "16px",
                    fontSize: "12px",
                    color: "#4B5563",
                    marginBottom: "20px",
                    marginTop: "20px",
                  }}
                >
                  {"Tanggal Buka Pengisian Jabatan Struktural " +
                    formatTanggal(date_open) +
                    ", Tanggal Tutup Pengisian Jabatan Struktural " +
                    formatTanggal(date_close)}
                </div>
                <div className="manage-registration">
                  <div className="fund-request__content">
                    <table className="table-structur">
                      <thead>
                        <tr>
                          <th>Jabatan</th>
                          <th>Nama Pegawai</th>
                        </tr>
                      </thead>
                      {/* <h1 style={{marginLeft:"100%"}}>Jabatan</h1> */}
                      <tbody>
                        {map(details, (list, idx) => (
                          <tr key={`budget_row_${idx}`}>
                            <td
                              key={`table_${idx}`}
                              style={{ textAlign: "left", fontWeight: "bold" }}
                            >
                              {list.position}
                            </td>
                            {(() => {
                              list.staff = list.nip;
                              // if(list.position.split(" ")[0] == 'Kepala' || list.position.split(" ")[0] == 'Tenaga'){
                              if (list.is_default == 1) {
                                return <td>{list.staff_name}</td>;
                              } else {
                                if (list.is_posting == 0) {
                                  return (
                                    <td key={`table__${idx}`}>
                                      <Select
                                        placeholder="Pilihan"
                                        data-input-array
                                        data-array-position={idx}
                                        data-field-name="details"
                                        name="nip"
                                        value={list.nip}
                                        error={list.error_nip}
                                        arrayPosition={idx}
                                        disabled={true}
                                        // data={form.value.graduate === 1?[...lulus, ...tidak_lulus]:[...naik, ...tidak_naik]}
                                        data={
                                          ["PL-58", "PL-59", "PL-60"].includes(
                                            list.position_code
                                          )
                                            ? this.state.availablePositions[
                                                idx
                                              ] || []
                                            : list.position_code === "PL-38"
                                            ? param.positions_adm
                                            : param.positions
                                        }
                                        onChange={this._onFormChange}
                                      />
                                    </td>
                                  );
                                } else {
                                  return <td>{list.staff_name}</td>;
                                }
                              }
                            })()}
                            {/* {this._renderButtons(list)} */}
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            )}
          </>
        )}
        {/* {(today < date_open || today >= date_close) && (
        <p>TIDAK ADA DATA</p>
         )} */}
      </div>
    );
  }
}
StrukturUnit.propTypes = {
  handleDelete: PropTypes.func,
  history: PropTypes.object.isRequired,
  user: PropTypes.object,
};
StrukturUnit.defaultProps = {
  handleDelete: noop,
  user: null,
};
